module.exports = __webpack_public_path__ + "static/media/table-sorting.ae033cfd.svg";